module.exports = __webpack_public_path__ + "static/media/mhi.bb2f9132.png";